import React, { useEffect } from 'react';
import RouteRequiresLogin from './LoggedOutSplash';
import { useGetCurrentUserQuery } from '../../../services/matches';


function PrivateRoute({ children, ..._rest }: { children?: React.ReactNode }) {
  const [showLoading, setShowLoading] = React.useState(true);
  const { data: user, isLoading } = useGetCurrentUserQuery();

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setShowLoading(false);
      }, 200);
    }
  }, [isLoading]);

  if (showLoading) {
    return <></>;
  } else {
    return (
      <>
        {user?.uid ? (
          children
        ) : (
          <React.Suspense fallback={null}>
            <RouteRequiresLogin />
          </React.Suspense>
        )}
      </>
    );
  }
}

export default PrivateRoute;
